import type {CSSProperties} from 'react';

function measurePropertyHeaderFrame(): CSSProperties | undefined {
  const header = document.querySelector('[data-entrance="property-header"]');
  const rect = header?.getBoundingClientRect();
  if (!rect || rect.height === 0) return undefined;

  return {
    '--t': `${Math.max(0, rect.top)}px`,
    '--l': `${rect.left}px`,
    '--r': `${window.innerWidth - rect.right}px`,
    '--b': `${Math.max(0, window.innerHeight - rect.bottom)}px`,
  } as CSSProperties;
}

export {measurePropertyHeaderFrame};
